export default __webpack_public_path__ + "static/media/logo-mercadopago.04846e8b.png";